import { scrollIntoView } from 'scroll-js';

export const scrollToElement = (elementId, callback = undefined) => {
  const target = document.getElementById(elementId);
  scrollIntoView(target, document.body, { behavior: 'smooth' }).then(() => {
    if (callback) {
      callback();
    }
  });
};

export function openChatWindow(isRetry = false) {
  if (typeof window === 'undefined') {
    return;
  }
  // @ts-ignore
  if (window.zE && window.$zopim && window.$zopim.livechat && window.$zopim.livechat.window) {
    // @ts-ignore
    window.zE(window.$zopim.livechat.window.show);
  } else if (!isRetry) {
    setTimeout(() => {
      openChatWindow(true);
    }, 5000); // Hopefully it's been loaded by now
  } else {
    console.warn('Zendesk is not available, opening new window');
    window.open(`https://kindur.zendesk.com/hc/en-us`, `_blank`);
  }
}
